// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6211":"2a028ab3","8805":"22438a6f"}[chunkId] + ".chunk.css";
};